
import {
orderSave,
availableConsume
} from '../api/order-cart.js'
import Api from '../api.js'
import Vue from 'vue'
import Alert from 'vux/src/components/alert/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import {isAlipayOrWechat} from '../utils/common.js'

export default {
data() {
return {
rName: "", //收花人名称
rMobile: "", //收花人手机号
purpose: "", //收花目的地
address: "", //收货地址
bookMobile: "", //订花人手机号
orderFee: "", //订单金额
goods: [], //商品列表
freight: "", //运费
couponDiscountFee: "", //优惠金额
code: "", //结算订单编号
imagesUrl: Api.imgUrl,
goodsFee: "", //商品总金额
rCityId:"",//cityCode值
rProvinceId:"",//省份citycode
voucherFlag:0,//是否显示购物金
shoppingVoucher:0,//购物金金额
isAgree:false,//是否勾选用户协议
consentAgree:false,//之前是否勾选了用户协议
showQuestion:false,//用户协议
gidListStr:""
};
},
directives: {
TransferDom
},
components: {
Alert,
Confirm,
Toast,
Loading
},
created() {
},
mounted: function() {
console.log("test--------", this.$store.state.orderInfo)
let orderInfo = this.$store.state.orderInfo;
let rCityId = this.$store.state.rCityId;
if(this.$store.state.rCityId != null && this.$store.state.rCityId != undefined && this.$store.state.rCityId != "" ){
this.rCityId = rCityId;
this.rProvinceId = rCityId.toString().substr(0,3) + "000";
}
this.rName = orderInfo.rName; 
this.rMobile = orderInfo.rMobile; 
this.purpose = orderInfo.purpose; 
this.address = orderInfo.address; 
this.bookMobile = orderInfo.bookMobile; 
this.orderFee = orderInfo.orderFee; 
this.goods = orderInfo.goods; 
this.freight = orderInfo.freight; 
this.couponDiscountFee = orderInfo.couponDiscountFee; 
this.code = orderInfo.code; 
this.goodsFee = orderInfo.goodsFee; 
this.voucherFlag = orderInfo.voucherFlag;
this.consentAgree = orderInfo.consentAgree;
this.isAgree = orderInfo.consentAgree;
this.gidListStr = this.$store.state.gidListStr;
this.selectGdList = this.$store.state.selectGdList;

console.log("结算的商品信息--------", this.$store.state.preData)

if(orderInfo.voucherFlag == 1){
this.getAvailableConsumeFun();
}

},
methods: {

orderSaveFun: function() {
let that = this;


if(!this.isAgree){
this.$vux.toast.text("请勾选用户协议", 'middle');
return;
}

let params = that.$store.state.preData; 


let orderFee = params.orderFee;
params.isAgree = this.isAgree;
params.consentAgree = this.consentAgree;


if(this.voucherFlag == 1){
params.shoppingVoucher = this.shoppingVoucher;
}
orderSave(params).then(res => {
console.log("返回--------", res)
if (res.code == 1 || res.code == 4) {

if(orderFee > 0){
let method = isAlipayOrWechat();

if(method == "wx"){
location.href = Api.wechatcart + '?code=' + res.data;
}else{

location.href = Api.alicart + '?code=' + res.data;
}
}else{

this.$router.push({
path:'/CartOrderdetail',
query:{
code:res.data
}
})
}
} else {
this.$vux.toast.text(res.desc, 'middle');
}
})
},


getAvailableConsumeFun:function(){
let that = this;
let rcgiList = [];
console.log("1111")

if(this.goods.length > 0){
for(let item in this.goods){

let goodsPrice = 0;

if(this.couponDiscountFee > 0){

if(this.goods[item].goodsFee == this.couponDiscountFee){
goodsPrice = 0;
}else{



let cNum = ((this.goods[item].goodsFee/this.goodsFee) * this.couponDiscountFee).toFixed(4);
let tnum =  cNum.substring(0, cNum.length - 2) + "";
goodsPrice = this.goods[item].goodsFee - tnum;
}
}else{

goodsPrice = this.goods[item].goodsFee;
}
let obj = {
gid:this.goods[item].spuId,
goodsPrice:goodsPrice
}
rcgiList.push(obj);
}

}

console.log("rcgiList-------",rcgiList)

availableConsume(this.orderFee,this.gidListStr,rcgiList).then(res => {
console.log("返回--------", res)
if (res.code == 1) {
that.shoppingVoucher = res.data;
that.orderFee = (that.orderFee - res.data).toFixed(2);
} else {

}
})
},


showQuestionFun:function(){
this.showQuestion = true;
},
closeQuestionFun:function(){
this.showQuestion = false;
},


consentAgreeFun:function(){
this.isAgree = !this.isAgree;
}

},
filters: {

}
}



// WEBPACK FOOTER //
// ./src/view/order-cart.vue